export const ETRIS01_DetailedAging = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Detailed Aging",
    binding: {
      data: {
        columns: [
          {
            name: "Billcollector Code",
            columnName: "BillcollectorCode",
            width: "200px",
            align: "left",
            sortable: true
          },
          {
            name: "Billcollector Name",
            columnName: "BillCollectorName",
            width: "200px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Code",
            columnName: "CustomerCode",
            width: "250px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Name",
            columnName: "CustomerName",
            width: "250px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Address",
            columnName: "CustomerAddress",
            width: "350px",
            align: "left",
            sortable: true
          },
          {
            name: "Ship To Code",
            columnName: "ShipToCode",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Ship To Address",
            columnName: "ShipToAddress",
            width: "350px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Classification",
            columnName: "CustomerClassification",
            width: "220px",
            align: "left",
            sortable: true
          },
          {
            name: "Order Type",
            columnName: "OrderType",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Transaction Date",
            columnName: "TransactionDate",
            width: "200px",
            align: "left",
            sortable: true
          },
          {
            name: "Due Date",
            columnName: "DueDate",
            width: "200px",
            align: "left",
            sortable: true
          },
          {
            name: "Check No.",
            columnName: "CheckNo",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Check Date",
            columnName: "CheckDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Credit Terms",
            columnName: "CreditTerms",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Type",
            columnName: "Type",
            width: "120px",
            align: "left",
            sortable: true
          },
          {
            name: "Invoice No.",
            columnName: "InvoiceNo",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "DR No.",
            columnName: "DRNo",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "CM No.",
            columnName: "CMNo",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Amount",
            columnName: "Amount",
            width: "120px",
            align: "right",
            sortable: true
          },
          {
            name: "PDCBC Amount",
            columnName: "PDCBCAmount",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Not Yet Due",
            columnName: "NotYetDue",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Current",
            columnName: "Current",
            width: "150px",
            align: "right",
            sortable: true
          },
          {
            name: "One Month",
            columnName: "OneMonth",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Two Months",
            columnName: "TwoMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Three Months",
            columnName: "ThreeMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Four Months",
            columnName: "FourMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Five Months",
            columnName: "FiveMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Six Months Over",
            columnName: "SixMonthsOver",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Balance",
            columnName: "Balance",
            width: "120px",
            align: "right",
            sortable: true
          },
          {
            name: "Principal",
            columnName: "Principal",
            width: "450px",
            align: "left",
            sortable: true
          },
          {
            name: "Area",
            columnName: "Area",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Region",
            columnName: "Region",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Province",
            columnName: "Province",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Remarks",
            columnName: "Remarks",
            width: "300px",
            align: "left",
            sortable: true
          }
        ],
        title: "BillcollectorCode",
        onLoad: "Pgn.IS01",
        subtotal: true,
        pagination: {
          show: true
        },
        endpoint: "ETRIS01",
        parameters: [
          {
            key: "PageIndex",
            value: "1"
          },
          {
            key: "ResultsPerPage",
            value: "10"
          }
        ]
      },
      context: {
        point: {
          onClick: {}
        }
      }
    }
  }
};